import React, { useState } from 'react';
import { Container, Row, Col, Card, Image } from 'react-bootstrap';
import BlogPost from '../Components/Sections/BlogPost';
import { Link } from 'react-router-dom';
import PageSubTitle from '../Components/Layout/PageSubTitle';
import TeamContent from '../data/food_data.json';

export default function Team() {
    const [TeamList] = useState(TeamContent);
    return (
        <>
            <PageSubTitle pagename="Our Chefs" />
            <section className='section'>
                <Container>
                    <Row>
                        {TeamList.TeamData.map((data, i) =>
                            <Col sm={6} md={4} xl={3} key={i}>
                                <Image src={require(`../images/team/${data.chefImg}`)} alt="" className='img-fluid w-100 rounded-3 png-img-shadow-sm' />

                                <Card className='text-center card-hover rounded-3 mx-3 mt-n4'>
                                    <Card.Body>
                                        <h5 className='fs-24 mb-1'>{data.chefName}</h5>
                                        <p className='text-muted fs-16 text-uppercase mb-4'>{data.chefInfo}</p>
                                        <div className='social-icons justify-content-center'>
                                            <Link to="/" className='social-icon'><i className="ri-facebook-circle-fill"></i></Link>
                                            <Link to="/" className='social-icon'><i className="ri-twitter-fill"></i></Link>
                                            <Link to="/" className='social-icon'><i className="ri-linkedin-box-fill"></i></Link>
                                            <Link to="/" className='social-icon'><i className="ri-skype-fill"></i></Link>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>
                        )}
                    </Row>
                </Container>
            </section>

            <BlogPost />
        </>
    )
}
